import { Input as NextUIInput } from '@nextui-org/react'
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form'

import type { ControlledInputProps } from './type'

export function Input<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  fieldProps,
  name,
  rules,
}: Readonly<ControlledInputProps<TFieldValues, TName>>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onBlur, onChange, value },
        fieldState: { error, invalid },
      }) => (
        <NextUIInput
          classNames={{
            label: 'uppercase',
          }}
          errorMessage={error?.message}
          isInvalid={invalid}
          isRequired={rules?.required as boolean}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          {...fieldProps}
        />
      )}
      rules={rules}
    />
  )
}

export default Input
